import axios from 'axios';
import { baseUrl } from '../utils/constants';

export const login = async ({ username, password }) => axios.post(
  `${baseUrl()}users/login/`,
  {
    username,
    password,
  },
  { withCredentials: true },
);

export const isLoggedIn = async () => axios.get(
  `${baseUrl()}users/isLoggedIn/`, { withCredentials: true },
);

export const logOut = async () => axios.get(
  `${baseUrl()}users/logOut/`, { withCredentials: true },
);

export const userTable = async (userSearch = '', page = 1, pageSize = 50) => axios.get(
  `${baseUrl()}r/users?page=${page}&pageSize=${pageSize}${userSearch ? `&search=${encodeURIComponent(userSearch)}` : ''}`, { withCredentials: true },
);

export const userRegister = async (payload) => axios.post(
  `${baseUrl()}users/register/`, payload, { withCredentials: true },
);

export const requestCompany = async (payload) => axios.post(
  `${baseUrl()}users/requestCompany/`, payload, { withCredentials: true },
);

export const userUpdate = async (payload) => axios.patch(
  `${baseUrl()}users/update/${payload.id}`, payload, { withCredentials: true },
);

export const userDetails = async (userId) => axios.get(
  `${baseUrl()}users/get/${userId}`, { withCredentials: true },
);

export const sendResetPassword = async (user) => axios.post(
  `${baseUrl()}users/password_reset/`, user, { withCredentials: true },
);

export const changePassword = async (payload) => axios.post(
  `${baseUrl()}users/password_reset/confirm/`, payload, { withCredentials: true },
);

export const getUser = async () => axios.get(
  `${baseUrl()}users/getUser/`, { withCredentials: true },
);

export const getUserByEmail = async (email) => axios.get(
  `${baseUrl()}users/getUserByEmail/${email}`, { withCredentials: true },
);

export const getActiveUsers = async () => axios.get(
  `${baseUrl()}users/getActiveUsers/`, { withCredentials: true },
);